import { createContext, useContext } from 'react';

export type ToastKind = 'success' | 'error' | 'info';

/** Optionaler Aktions-Button auf einem Toast (z.B. „Rückgängig"). */
export type ToastAction = { label: string; onClick: () => void };

export type ToastApi = {
  success: (message: string) => void;
  error: (message: string) => void;
  info: (message: string) => void;
  /**
   * Toast mit Aktions-Button (Default-Kind `info`). Längeres Auto-Dismiss als
   * normale Toasts, damit der User die Aktion (z.B. Undo) noch klicken kann.
   */
  withAction: (message: string, action: ToastAction, kind?: ToastKind) => void;
};

export const ToastContext = createContext<ToastApi | null>(null);

export function useToast(): ToastApi {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast() benötigt einen <ToastProvider> im Tree.');
  return ctx;
}
